import {
  GroupsManagerEnrollmentsOrderByFieldsEnum,
  GroupsManagerEnrollmentsSearchableFieldsEnum,
  GroupsManagerGroupChangesOrderByFieldsEnum,
  GroupsManagerGroupChangesSearchableFieldsEnum,
  GroupsManagerSearchOrderByFields,
  GroupsManagerSearchSearchableFieldsEnum,
  OrderByDirection,
} from "@models/ISchema";
import { TableFiltersReducerType } from "./types";
import {
  EnrollmentsTableColumn,
  GroupsChangesTableColumn,
  GroupsManagerTableColumn,
  SubGroupsTableColumn,
} from "../models";

export const setAll = (
  newState: TableFiltersReducerType,
  _state: TableFiltersReducerType,
): TableFiltersReducerType => {
  void _state;
  return newState;
};

/**
 * Set the columnsToHide.
 *
 * @param columnsToHide The columns to hide.
 *
 * @returns TableFiltersReducerType.
 */
export const setColumnsToHide = (
  columnsToHide: Set<GroupsManagerTableColumn>,
  state: TableFiltersReducerType,
): TableFiltersReducerType => {
  return { ...state, columnsToHide: new Set(columnsToHide) };
};

/**
 * Set the orderBy's `field` and `direction`.
 *
 * @param orderBy The orderBy object.
 * @param state The current state.
 *
 * @returns TableFiltersReducerType.
 */
export const setOrderBy = (
  orderBy: {
    header:
      | GroupsManagerTableColumn
      | GroupsChangesTableColumn
      | SubGroupsTableColumn
      | EnrollmentsTableColumn;
    field:
      | GroupsManagerSearchOrderByFields
      | GroupsManagerGroupChangesOrderByFieldsEnum
      | GroupsManagerEnrollmentsOrderByFieldsEnum;
    direction: OrderByDirection;
  },
  state: TableFiltersReducerType,
): TableFiltersReducerType => {
  return { ...state, orderBy };
};

/**
 * Set the searchBy's `fields`.
 *
 * @param fields The fields to search by.
 * @param state The current state.
 *
 * @returns TableFiltersReducerType.
 */
export const setSearchByFields = (
  fields:
    | GroupsManagerSearchSearchableFieldsEnum[]
    | GroupsManagerGroupChangesSearchableFieldsEnum[]
    | GroupsManagerEnrollmentsSearchableFieldsEnum[],
  state: TableFiltersReducerType,
): TableFiltersReducerType => {
  return { ...state, searchBy: { ...state.searchBy, fields } };
};

/**
 * Set the searchBy's `text`.
 *
 * @param text The text to search.
 * @param state The current state.
 *
 * @returns TableFiltersReducerType.
 */
export const setSearchByText = (
  text: string,
  state: TableFiltersReducerType,
): TableFiltersReducerType => {
  return { ...state, searchBy: { ...state.searchBy, text } };
};
